import { render, staticRenderFns } from "./OrgModules.vue?vue&type=template&id=4bb2356a&scoped=true"
import script from "./OrgModules.vue?vue&type=script&lang=js"
export * from "./OrgModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2356a",
  null
  
)

export default component.exports